<template>
  <div class="page-result">
    <div class="page-result-header">
      <div class="cover"><img :src="image" alt="cover" /></div>
      <div class="title">{{ title }}</div>
      <div class="content">{{ desc }}</div>
    </div>
    <slot></slot>
    <div class="page-result-footer">
      <page-footer :showHotline="showHotline" />
    </div>
  </div>
</template>
<script>
import PageFooter from '@/components/PageFooter';
export default {
  props: ['image', 'title', 'desc', 'showHotline'],
  components: {
    PageFooter,
  },
};
</script>

<style lang="less">
.page-result {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  background-color: #ffffff;

  &-header {
    padding: 96px 64px 24px;
    text-align: center;
    background-color: #ffffff;

    .cover {
      width: 150px;
      margin: 0 auto;
      img {
        width: 100%;
        height: auto;
      }
    }

    .title {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 500;
      color: #4a4a4a;
    }

    .content {
      margin-top: 10px;
      font-size: 14px;
      color: #9b9b9b;
    }
  }

  &-footer {
    margin-top: auto;
  }
}
</style>
